var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import NotificationBar from "syf-component-library/ui/patterns/NotificationBar";
import styled from "styled-components";
export var FirstNotification = styled(NotificationBar)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  left: 0;\n  right: 0;\n"], ["\n  left: 0;\n  right: 0;\n"])));
export var NotificationTitle = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  justify-content: space-between;\n"])));
var templateObject_1, templateObject_2;
//# sourceMappingURL=subcomponents.js.map